import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({ providedIn: 'root' })
export class CareerPageService {
    private _route = '/api/career-pages/';
    private headerOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    constructor(private httpClient: HttpClient) { }

    getAll(): Observable<any[]> {
        return this.httpClient.get<any[]>(this._route);
    }


    getBySlug(slug: string): Observable<any> {
        return this.httpClient.get<any>(this._route + slug);
    }


    getWordAnimClass(animationType?: string): string {
        return animationType === 'fade-up-scroll'
            ? 'fade-in-up-animation-wait-for-visible'
            : 'fade-in-up-animation';
    }


    getWordDelay(index: number, animationType?: string): number {
        const baseDelay = 250;
        if (animationType === 'fade-up-stagger' || animationType === 'fade-up-scroll') {
            return baseDelay + (index * 30);
        }
        return animationType === 'fade-up' ? baseDelay : 0;
    }
}